import React, { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { Grid, GridColumn } from 'components/page';
import { gridSize } from 'components/theme/constants';
import { ThemeProvider } from 'styled-components';

const Padding = styled.div`
  // margin: ${gridSize() * 2}px ${gridSize() * 0}px;
  padding-top: ${gridSize() * 2}px;
  padding-bottom: ${gridSize() * 4}px;
  padding-left: ${gridSize() * 1}px;
  padding-right ${gridSize() * 1}px;
`;

type PageWrapperProps = {
  fullWidth?: boolean;
}

const gridTheme = {};
const PageWrapper: FunctionComponent<PageWrapperProps> = ({ fullWidth, children }) => (
  <Padding>
    <ThemeProvider theme={gridTheme}>
      <Grid layout={fullWidth ? 'fluid' :'fixed'} spacing="comfortable">
        <GridColumn>{children}</GridColumn>
      </Grid>
    </ThemeProvider>
  </Padding>
);

PageWrapper.defaultProps = {
  fullWidth: false,
};

export default React.memo(PageWrapper) as typeof PageWrapper;
